export default __webpack_public_path__ + "static/media/panoptic-chart.0783e127.png";